<ng-container *ngIf="(showLayout$ | async); else showOnlyRouterOutlet">
  <!-- Layout for Non-Login Pages -->
  <mat-sidenav-container class="app-container" autosize>
    <!-- Sidebar -->
    <mat-sidenav
      mode="side"
      opened
      class="app-sidenav"
      [class.sidenav-collapsed]="!isSidebarExpanded"
    >
      <!-- Render app-sidebar only ONCE -->
      <app-sidebar
      [userName]="(currentUser$ | async)?.firstName ?? ''"
      [userSurname]="(currentUser$ | async)?.lastName ?? ''"
      [isExpanded]="isSidebarExpanded"
      (toggle)="toggleSidebar()">
      </app-sidebar>
    </mat-sidenav>

    <!-- Main Content Area -->
    <mat-sidenav-content class="app-content">
      <!-- Header -->
      <app-header></app-header>

      <!-- Routed Component Content -->
      <main>
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>

<!-- Template to show ONLY the router-outlet (for the login page) -->
<ng-template #showOnlyRouterOutlet>
  <router-outlet></router-outlet>
</ng-template>